<div class="modal-header">
    <h4 class="modal-title">{{ message }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" *ngIf="!isAutoAccept">
    <div class="w-100">
        <div class="d-flex align-items-center gap-4 w-100 mt-auto">
            <button class="primary_btn w-100 text-white" data-dismiss="modal" i18n="@@orders.accept" (click)="accept()">Accept</button>
            <button class="secondary_btn w-100" data-dismiss="modal" i18n="@@orders.reject" (click)="reject()">Reject</button>
        </div>
    </div>
</div>